import { LicenceId } from '@ps/platform-message-framework/common/LicenceId';
import { StarsButton as Button, Translation } from '@ps/web-shared-components';
import React from 'react';
import type { SyntheticEvent } from 'react';
import { useDispatch } from 'react-redux';

import type { CardViewProps } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { geti18NValueConfig } from '@swf/components/StarsMPNotification/utils';
import LicensedTranslation from '@swf/components/Translation/LicensedTranslation';
import freeSpinsIcon from '@swf/core/assets/casino/free-spins.png';
import type { Dispatch } from '@swf/core/store';
import type { FreeSpinsNotification } from '@swf/core/types/Notification';
import { NotificationContainer } from '@swf/notification';

import sharedStyles from '../../../styles/shared.scss';
import Buttons from '../../Buttons/Buttons';
// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../FreeSpins.scss';

import {
  TXTCLI_More_information,
  TXTCLI_On_expiry_any_remaining_spins__ELL,
  TXTCLI_Your_N0_Free_Spins_will_expire_ELL,
  TXTINT_FORMAT_LongTime
} from './Expired.messages.json';

const Expired: React.FC<CardViewProps & { cardData: FreeSpinsNotification }> = ({
  cardData: { type, description, attributes, notificationId, rollId, expiresIn },
  viewConfig: { title, actions },
  onClickPrimaryAction
}) => {
  const { modal } = useDispatch<Dispatch>();

  const viewBonuses = (e: SyntheticEvent) => {
    e.preventDefault();
    modal.replace([{ path: `/account/my-stars/bonus/free-spin-bonuses/${rollId}` }]);
  };

  return (
    <NotificationContainer
      title={<Translation {...title.tag} values={geti18NValueConfig(title.values, attributes)} />}
      bodyClass={sharedStyles.containerBody}
    >
      <img className={styles.freeSpins} src={freeSpinsIcon} alt="Free Spins Icon" />
      {expiresIn && (
        <Translation
          tagName="p"
          {...TXTCLI_Your_N0_Free_Spins_will_expire_ELL}
          values={{
            0: description,
            1: (
              <Translation
                {...TXTINT_FORMAT_LongTime}
                values={{ 0: expiresIn.hours, 1: expiresIn.minutes }}
              >
                {(translation) => <span className={sharedStyles.nowrap}>{translation}</span>}
              </Translation>
            )
          }}
        />
      )}

      <LicensedTranslation
        tagName="p"
        include={[LicenceId.ITALY]}
        {...TXTCLI_On_expiry_any_remaining_spins__ELL}
      />

      <Button
        variant="text"
        onClick={viewBonuses}
        className={styles.moreInfoBtn}
        translation={TXTCLI_More_information}
      />

      <Buttons
        actionList={actions}
        notificationType={type}
        attributes={attributes}
        notificationId={notificationId}
        onClickPrimaryAction={onClickPrimaryAction}
      />
    </NotificationContainer>
  );
};

export default Expired;
